import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getObjectFitOptions = ({
  defaultValue = "cover",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getObjectPositionOptions = ({
  defaultValue = "center",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "select",
  value: defaultValue,
});

export const getImageOpacityOptions = ({
  defaultValue = 1,
}: {
  defaultValue?: number;
}): StyleValue => ({
  type: "number",
  value: defaultValue,
});

export const getBorderRadiusOptions = ({
  defaultValue = {
    border_left_top_radius: 2,
    border_left_bottom_radius: 2,
    border_right_top_radius: 2,
    border_right_bottom_radius: 2,
  },
}: {
  defaultValue?: {
    border_left_top_radius: string | number;
    border_left_bottom_radius: string | number;
    border_right_top_radius: string | number;
    border_right_bottom_radius: string | number;
  };
}): StyleValue => ({
  type: "border-radius",
  value: {
    border_left_top_radius: defaultValue.border_left_top_radius,
    border_left_bottom_radius: defaultValue.border_left_bottom_radius,
    border_right_top_radius: defaultValue.border_right_top_radius,
    border_right_bottom_radius: defaultValue.border_right_bottom_radius,
  },
});
